export default __webpack_public_path__ + "static/media/Untitled_Artwork.eb27daee.png";